// extracted by mini-css-extract-plugin
export var colorSquare = "_ke-0";
export var danger = "_ke-5";
export var lightPink = "_ke-8";
export var neutralBlue = "_ke-7";
export var neutralYellow = "_ke-6";
export var normal = "_ke-1";
export var primary = "_ke-2";
export var primaryLight = "_ke-3";
export var solidBlack = "_ke-g";
export var solidGreen = "_ke-b";
export var solidLightBlue = "_ke-d";
export var solidNavy = "_ke-c";
export var solidOrange = "_ke-f";
export var solidPink = "_ke-e";
export var solidRed = "_ke-9";
export var solidYellow = "_ke-a";
export var success = "_ke-4";